import { THUMBNAIL_SIZE } from '~/domain/shared/models/thumbnail-size';
import { cn } from '~/styles/extended-theme';

import { Spinner } from '../ui/spinner';

export type Variant = 'person' | 'default';

export default function FallbackThumbnail({
  size,
  alt = '',
  rounded,
  variant = 'default',
  showSpinner = false,
  spinnerColor = 'white',
  imageClassName,
}: {
  size: THUMBNAIL_SIZE;
  alt?: string;
  rounded?: boolean;
  variant?: Variant;
  showSpinner?: boolean;
  spinnerColor?: 'white' | 'primary';
  imageClassName?: string;
}) {
  return (
    <>
      <img
        src={getThumbnailUrl(size, variant)}
        alt={alt}
        className={cn(
          'max-h-full max-w-full object-contain',
          rounded ? 'rounded-2xl' : null,
          imageClassName,
        )}
      />
      {showSpinner ? (
        <Spinner
          className="absolute bottom-0 left-0 right-0 top-0 m-auto"
          color={spinnerColor}
          showSpinner
          size="sm"
        />
      ) : null}
    </>
  );
}

const getThumbnailUrl = (size: THUMBNAIL_SIZE, variant: Variant) => {
  if (variant === 'person') {
    switch (size) {
      case THUMBNAIL_SIZE.SQUARE_EXTRA_SMALL:
        return '/img/person_96x96.png';
      case THUMBNAIL_SIZE.SQUARE_SMALL:
        return '/img/person_230x230.png';
      default:
        return '/img/person_512x512.png';
    }
  }

  // todo: Replace these urls with our internal images that we create
  switch (size) {
    case THUMBNAIL_SIZE.SQUARE_EXTRA_SMALL:
      return '/img/fp_placeholder_gymlist.png';
    case THUMBNAIL_SIZE.SQUARE_SMALL:
      return '/img/fp_placeholder_gymlist.png';
    case THUMBNAIL_SIZE.SMALL:
      return '/img/fp_placeholder_gymlist_large.png';
    case THUMBNAIL_SIZE.MEDIUM:
    case THUMBNAIL_SIZE.GYM_EVENT:
      return '/img/fp_placeholder_gymlist_large.png';
  }
};
